// Base API URL - centralized configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Helper function to build full URLs
const buildApiUrl = (path: string): string => {
  if (!path) return '';
  // If path already has domain, return as is (for backward compatibility)
  if (path.startsWith('http')) return path;
  // Otherwise, combine base URL with path
  return `${API_BASE_URL}${path}`;
};

const contentFolderApiUrls: any = {
  createFolder: buildApiUrl(process.env.REACT_APP_API_CONTENT_FOLDER_CREATEFOLDER || ''),
  deleteFolder: (folderId: string) => buildApiUrl(process.env.REACT_APP_API_CONTENT_FOLDER_DELETEFOLDER?.replace('{folder_id}', folderId) || ''),
  listFolders: (type: string) => buildApiUrl(process.env.REACT_APP_API_CONTENT_FOLDER_LISTFOLDER?.replace('{type}', type) || ''),
  updateFolder: buildApiUrl(process.env.REACT_APP_API_CONTENT_FOLDER_UPDATEFOLDER || ''),
  deleteFaqPtGroup: (type: string, folderId: any) => buildApiUrl(process.env.REACT_APP_API_CONTENT_MANAGEMENT_DELETE_GROUP_FAQ_PASTTICKET?.replace('{folderId}', folderId)?.replace('{type}', type) || ''),
  getIntegrationsToolsForTenants: buildApiUrl(process.env.REACT_APP_API_CONTENT_MANAGEMENT_GET_INTEGRATION_TOOLS_FOR_TENANTS || ''),
  getIntegrationsForTools: (tool: any) => buildApiUrl(process.env.REACT_APP_API_CONTENT_MANAGEMENT_GET_INTEGRATION_FOR_SELECTED_TOOLS?.replace('{tool}', tool) || ''),
  importPastTickets: buildApiUrl(process.env.REACT_APP_API_CONTENT_MANAGEMENT_IMPORT_PAST_TICKETS || ''),
  listScheduler: buildApiUrl(process.env.REACT_APP_API_CONTENT_MANAGEMENT_GET_SCHEDULER_LIST || ''),
  createScheduler: buildApiUrl(process.env.REACT_APP_API_CREATE_SCHEDULER || ''),
  deleteScheduler: (schedulerId: string) => buildApiUrl(process.env.REACT_APP_API_DELETE_SCHEDULER?.replace('{scheduler_id}', schedulerId) || ''),
  updateScheduler: buildApiUrl(process.env.REACT_APP_API_UPDATE_SCHEDULER || ''),
  getSchedulerHistory: (schedulerId: string) => buildApiUrl(process.env.REACT_APP_API_GET_SCHEDULER_HISTORY?.replace('{scheduler_id}', schedulerId) || ''),
}

const fileManagerAPIUrls: any = {
  listFiles: (folderId: string) => buildApiUrl(process.env.REACT_APP_API_FILE_MANAGER_LISTFILE?.replace("{folder_id}", folderId) || ''),
  updateFile: buildApiUrl(process.env.REACT_APP_API_FILE_MANAGER_UPDATEFILE || ''),
  deleteFile: (fileId: string) => buildApiUrl(process.env.REACT_APP_API_FILE_MANAGER_DELETEFILE?.replace("{file_id}", fileId) || ''),
  listRowContents: (type: any, folderId: any) => buildApiUrl(process.env.REACT_APP_API_CONTENT_MANAGEMENT_GET_GROUP_CONTENT?.replace('{type}', type)?.replace('{folder_id}', folderId) || ''),
  deleteRowContent: (type: any, rowId: any) => buildApiUrl(process.env.REACT_APP_API_CONTENT_MANAGEMENT_DELETE_GROUP_CONTENT?.replace('{type}', type)?.replace('{rowId}', rowId) || ''),
  deleteTicketsFaqPt: (rowId: any, type: any) => buildApiUrl(process.env.REACT_APP_API_CONTENT_MANAGEMENT_DELETE_TICKET_FAQ_PASTTICKET?.replace('{row_id}', rowId)?.replace('{type}', type) || ''),
  uploadFilesCount: (folderId: any) => buildApiUrl(process.env.REACT_APP_API_CONTENT_MANAGEMENT_FETCH_UPLOAD_COUNT_KNOWLEDGE_BASE?.replace('{folder_id}', folderId) || ''),
  uploadRetryFiles: buildApiUrl(process.env.REACT_APP_API_CONTENT_MANAGEMENT_UPLOAD_RETRY_FILES || '')
}

const promptManagerAPIUrls: any = {
  listPromptTemplates: buildApiUrl(process.env.REACT_APP_API_PROMPT_MANAGER_TEMPLATELIST || ''),
  listPromptsPublished: buildApiUrl(process.env.REACT_APP_API_PROMPT_MANAGER_LIST || ''),
  listPromptsDraft: buildApiUrl(process.env.REACT_APP_API_PROMPT_MANAGER_LIST_DRAFT || ''),
  addPromptFeedback: buildApiUrl(process.env.REACT_APP_API_PROMPT_MANAGER_FEEDBACK || ''),
  managePrompts: buildApiUrl(process.env.REACT_APP_API_PROMPT_MANAGER_MANAGE || ''),
  listPromptHistory: (promptId: string) => buildApiUrl(process.env.REACT_APP_API_PROMPT_MANAGER_TESTLIST?.replace("{prompt_id}", promptId) || ''),
  publishPrompt: buildApiUrl(process.env.REACT_APP_API_PROMPT_MANAGER_PUBLISH || ''),
  getPromptDetails: (id: string, type: string) => buildApiUrl(process.env.REACT_APP_API_PROMPT_MANAGER_DETAILS?.replace("{id}", id) || ''),
  getPromptTemplateDetails: (id: string, type: string) => buildApiUrl(process.env.REACT_APP_API_PROMPT_MANAGER_DETAILS_TEMPLATE?.replace("{template_id}", id) || ''),
  deletePrompt: buildApiUrl(process.env.REACT_APP_API_PROMPT_MANAGER_DELETE || ''),
}

const appManagerAPIUrls: any = {
  insertApp: process.env.REACT_APP_API_APP_MANAGER_CREATE,
  updateApp: process.env.REACT_APP_API_APP_MANAGER_UPDATE,
  publishApp: process.env.REACT_APP_API_APP_MANAGER_PUBLISH,
  getAppDetails: (appId: string) => process.env.REACT_APP_API_APP_MANAGER_DETAILS?.replace("{id}", appId),
  getPublishedAppDetails: (appId: string, type: any) => process.env.REACT_APP_API_APP_PUBLISHED_EDIT?.replace("{app_id}", appId)?.replace("{type}", type),
  getAppDetailsTemplate: (appId: string) => process.env.REACT_APP_API_APP_MANAGER_DETAILS_TEMPLATE?.replace("{id}", appId),
  getAppTemplateDetails: process.env.REACT_APP_API_APP_MANAGER_TEMPLATELIST,
  deleteApp: (appId: string) => process.env.REACT_APP_API_APP_MANAGER_DELETE?.replace("{app_id}", appId),
  validateDeletion: (appId: string) => process.env.REACT_APP_API_APP_DESIGNER_VALIDATE_DELETION?.replace("{app_id}", appId),
  listAppHistory: (appId: string) => process.env.REACT_APP_API_APP_MANAGER_HISTORYLIST?.replace("{app_id}", appId),
  listAppVersions: (appId: string, type: string) => process.env.REACT_APP_API_APP_MANAGER_VERSION?.replace("{app_id}", appId).replace("{type}", type),
  listRunHistory: (appId: string) => process.env.REACT_APP_API_APP_MANAGER_APP_RUN_HISTORY?.replace("{app_id}", appId),
  listAppPublished: process.env.REACT_APP_API_APP_MANAGER_LIST_PUBLISHED,
  listAppDraft: process.env.REACT_APP_API_APP_MANAGER_LIST_DRAFT,
  //testApp: `/orchestrator/app_orchestrator`,
  getAppTags: () => process.env.REACT_APP_API_APP_MANAGER_APP_TAGS,
  bulkRunStatus: (appId: any, execId: any, type: any) => process.env.REACT_APP_API_APP_MANAGER_APP_BULK_RUN_STATUS?.replace("{app_id}", appId).replace("{execution_id}", execId).replace("{type}", type),
  appShareTest: (app_id: any) => process.env.REACT_APP_API_APPSHARE_ORCHESTRATOR?.replace("{appId}", app_id),
  getAppShareDetails: (appId: string) => process.env.REACT_APP_API_APPSHARE_MANAGER_DETAILS?.replace("{id}", appId),
  appShareLinkGeneration: process.env.REACT_APP_API_APPSHARE_LINK_GENERATION,
  appShareLinkValidation: process.env.REACT_APP_API_APPSHARE_LINK_VALIDATION,
  bulkrunStatusApp: process.env.REACT_APP_API_BULKRUN_STATUS_APP_SPECIFIC,
  bulkrunTerminateRun: process.env.REACT_APP_API_BULK_RUN_TERMINATE_RUN,
  bulkrunExecuteBulkrun: process.env.REACT_APP_API_BULK_RUN_EXECUTE_RUN,
  appApiIntegate: process.env.REACT_APP_API_APP_API_INTEGRATE,
  setAsDefault: process.env.REACT_APP_API_APP_MANAGER_SETASDEFAULT_VERSION,
  setAsTemplate: process.env.REACT_APP_API_APP_MANAGER_SETASTEMPLATE,
  listTemplateVersions: (appId: string) => process.env.REACT_APP_API_APP_MANAGER_TEMPLATE_VERSION?.replace("{app_id}", appId),
  appInsights: (appType: string) => process.env.REACT_APP_API_APP_INSIGHT?.replace('{app_type}', appType),
  addAppFeedback: process.env.REACT_APP_API_APP_MANAGER_FEEDBACK,
  listAgentsInApp: process.env.REACT_APP_API_APP_LIST_AGENTS,
  updateDatabaseBlock: process.env.REACT_APP_API_APP_MANAGER_UPDATE_DATABASE_BLOCK,
  updateScheduleStatus: process.env.REACT_APP_API_APP_MANAGER_UPDATE_SCHEDULE_STATUS,
  pdfDownload: process.env.REACT_APP_API_APP_MANAGER_PDF_DOWNLOAD,
  exportWorkflow: (appId: string) => process.env.REACT_APP_API_WORKFLOW_EXPORT?.replace("{app_id}", appId),
  importWorkflow: process.env.REACT_APP_API_WORKFLOW_IMPORT,
}

const orchestratorApiUrls: any = {
  promptChat: buildApiUrl(process.env.REACT_APP_API_PROMPT_ORCHESTRATOR || ''),
  appChat: buildApiUrl(process.env.REACT_APP_API_APP_ORCHESTRATOR || '')
}

const llmConfigUrls: any = {
  create: buildApiUrl(process.env.REACT_APP_API_LLM_CONFIG_CREATE || ''),
  update: buildApiUrl(process.env.REACT_APP_API_LLM_CONFIG_UPDATE || ''),
  delete: (id: string) =>
    buildApiUrl((process.env.REACT_APP_API_LLM_CONFIG_DELETE || '').replace('{id}', id)),
}

const systemConfigUrls: any = {
  getSystemConfig: buildApiUrl(process.env.REACT_APP_API_SYSTEM_CONFIG_FETCH_DATA || ''),
  getTags: buildApiUrl(process.env.REACT_APP_API_SYSTEM_MANAGER_TAGS || ''),
  getLLMModels: buildApiUrl(process.env.REACT_APP_API_SYSTEM_MANAGER_LLM_MODELS || ''),
  getVectorDb: buildApiUrl(process.env.REACT_APP_API_SYSTEM_MANAGER_VECTOR_DB || ''),
  getVisionModels: buildApiUrl(process.env.REACT_APP_API_SYSTEM_MANAGER_VISION_MODELS || ''),
  getVoiceModels: buildApiUrl(process.env.REACT_APP_API_SYSTEM_MANAGER_VOICE_MODELS || ''),
  getModels: buildApiUrl(process.env.REACT_APP_API_SYSTEM_MANAGER_MODELS || ''),
  getEmbeddingModels: buildApiUrl(process.env.REACT_APP_API_SYSTEM_MANAGER_EMBEDDING_MODLES || ''),
}

const fileUrls: any = {
  uploadFile: (action: any) => buildApiUrl(process.env.REACT_APP_API_CONTENT_FILEMANAGER_UPLOADFILE?.replace("{action}", action) || ''),
  upoadFileAsync: '/uploadContentAsync?code=L4FIatbQomJcKkGE94dtBoTJq2ckubg_CNxExzhOVnLiAzFuE_5EMA==',
  uploadFileUsingLink: buildApiUrl(process.env.REACT_APP_API_FILEUPLOAD || ''),
  uploadFileSASgenration: buildApiUrl(process.env.REACT_APP_API_SAS_TOKEN_GENERATE_FILEUPLOAD || ''),
  uploadFileConfluence: buildApiUrl(process.env.REACT_APP_API_CONTENT_FILEMANAGER_UPLOADCONFLUENCE || ''),
  uploadFileSlack: buildApiUrl(process.env.REACT_APP_API_CONTENT_FILEMANAGER_UPLOADSLACK || ''),
  uploadFileSlackChannels: buildApiUrl(process.env.REACT_APP_API_CONTENT_FILEMANAGER_UPLOADSLACK_CHANNELS || ''),
  uploadFileSharePoint: buildApiUrl(process.env.REACT_APP_API_CONTENT_FILEMANAGER_UPLOAD_SHAREPOINT_PAGES || ''),
  uploadFileFromAppShare: buildApiUrl(process.env.REACT_APP_API_FILEUPLOAD_FROM_APPSHARE || ''),
}

const userManagementUrls: any = {
  enableDisableUser: buildApiUrl(process.env.REACT_APP_API_USER_MANAGEMENT_ENABLE_AND_DISABLE || ''),
  listUsers: (tenantType: any) => buildApiUrl(process.env.REACT_APP_API_USER_MANAGEMENT_LIST_USERS?.replace("{tenantType}", tenantType) || ''),
  updateUserDeatils: buildApiUrl(process.env.REACT_APP_API_USER_MANAGEMENT_UPDATE_USER_DETAILS || ''),
  createUser: buildApiUrl(process.env.REACT_APP_API_USER_MANAGEMENT_CREATE_USER_DETAILS || ''),
  deleteUser: (userId: any) => buildApiUrl(process.env.REACT_APP_API_USER_MANAGEMENT_DELETEE_USER?.replace("{user_id}", userId) || ''),
  getUserDetails: (userId: any) => buildApiUrl(process.env.REACT_APP_API_USER_MANAGEMENT_GET_USER_DETAILS?.replace("{user_id}", userId) || ''),
  emailInvite: buildApiUrl(process.env.REACT_APP_API_USER_MANAGEMENT_EMAIL_INVITE || '')
}

const tenantManagement: any = {
  listTenants: buildApiUrl(process.env.REACT_APP_API_TENANT_MANAGEMENT_LIST_TENANTS || ''),
  createTenants: buildApiUrl(process.env.REACT_APP_API_TENANT_MANAGEMENT_CREATE_TENANTS || ''),
  getTenantDetails: buildApiUrl(process.env.REACT_APP_API_TENANT_MANAGEMENT_GET_TENANT_DETAILS || ''),
  updateTenants: buildApiUrl(process.env.REACT_APP_API_TENANT_MANAGEMENT_UPDATE_TENANT || ''),
  deleteTenant: (Id: any) => buildApiUrl(process.env.REACT_APP_API_TENANT_MANAGEMENT_DELETE_TENANT?.replace("{tenant_doc_id}", Id) || ''),
  disableTenant: (Id: any) => buildApiUrl(process.env.REACT_APP_API_TENANT_MANAGEMENT_DISABLE_TENANT?.replace("{tenant_doc_id}", Id) || ''),
  enableTenant: (Id: any) => buildApiUrl(process.env.REACT_APP_API_TENANT_MANAGEMENT_ENABLE_TENANT?.replace("{tenant_doc_id}", Id) || ''),
  getTenantGroups: (Id: any) => buildApiUrl(process.env.REACT_APP_API_TENANT_MANAGEMENT_GET_TENANT_GROUPS?.replace("{tenant_id}", Id) || ''),
  saveTenantGroups: buildApiUrl(process.env.REACT_APP_API_TENANT_MANAGEMENT_SAVE_TENANT_GROUPS || ''),
  getSubscriptionDetails: buildApiUrl(process.env.REACT_APP_API_TENANT_MANAGEMENT_GET_SUBSCRIPTION_DETAILS || ''),
}

const accessManagement: any = {
  listAccess: buildApiUrl(process.env.REACT_APP_API_ACCESS_MANAGEMENT_LIST_ACCESS || ''),
  deleteAccess: (access_id: any) => buildApiUrl(process.env.REACT_APP_API_ACCESS_MANAGEMENT_DELETE_ACCESS?.replace("{access_id}", access_id) || ''),
  workspaceAccess: buildApiUrl(process.env.REACT_APP_API_WORKSPACE_ACCESS || ''),
}

const rolesManagement: any = {
  listRoles: buildApiUrl(process.env.REACT_APP_API_ROLE_MANAGEMENT_LIST_ROLES || ''),
  createRole: buildApiUrl(process.env.REACT_APP_API_ROLE_MANAGEMENT_CREATE_ROLES || ''),
  updateRole: buildApiUrl(process.env.REACT_APP_API_ROLE_MANAGEMENT_UPDATE_ROLES || ''),
  deleteRole: (roleId: any) => buildApiUrl(process.env.REACT_APP_API_ROLE_MANAGEMENT_DELETE_ROLES?.replace("{role_id}", roleId) || ''),
  getUserMappedRoles: (role: any) => buildApiUrl(process.env.REACT_APP_API_ROLE_MANAGEMENT_GET_USER_MAPPED_ROLES?.replace('{role}', role) || ''),
}

const packageManagement: any = {
  listPackages: buildApiUrl(process.env.REACT_APP_API_PACKAGE_MANAGEMENT_LIST_PACKAGES || ''),
  createPackages: buildApiUrl(process.env.REACT_APP_API_PACKAGE_MANAGEMENT_CREATE_PACKAGES || ''),
  updatePackages: buildApiUrl(process.env.REACT_APP_API_PACKAGE_MANAGEMENT_UPDATE_PACKAGES || ''),
  deletePackages: (packageId: any) => buildApiUrl(process.env.REACT_APP_API_PACKAGE_MANAGEMENT_DELETE_PACKAGES?.replace("{package_id}", packageId) || ''),
  listAppForPackage: buildApiUrl(process.env.REACT_APP_API_PACKAGE_MANAGEMENT_LIST_APPS_PACKAGES || ''),
  listAppGeneral: buildApiUrl(process.env.REACT_APP_API_PACKAGE_MANAGEMENT_LIST_APPS_GENERAL || '')
}

const productManagement: any = {
  listProducts: buildApiUrl(process.env.REACT_APP_API_PRODUCT_MANAGEMENT_LIST_PRODUCTS || ''),
  updateProducts: buildApiUrl(process.env.REACT_APP_API_PRODUCT_MANAGEMENT_UPDATE_PRODUCTS || '')
}

const integrationManagement: any = {
  listIntegrations: buildApiUrl(process.env.REACT_APP_API_INTEGRATION_MANAGEMENT_LIST_INTEGRATIONS || ''),
  masterTenantIntegrations: buildApiUrl(process.env.REACT_APP_API_INTEGRATION_MANAGEMENT_MASTER_TENANT_INTEGRATIONS || ''),
  deleteIntegration: (integrationId: any) => buildApiUrl(process.env.REACT_APP_API_INTEGRATION_MANAGEMENT_DELETE_INTEGRATIONS?.replace("{integration_id}", integrationId) || ''),
  createIntegration: buildApiUrl(process.env.REACT_APP_API_INTEGRATION_MANAGEMENT_CREATE_INTEGRATIONS || ''),
  updateIntegration: buildApiUrl(process.env.REACT_APP_API_INTEGRATION_MANAGEMENT_UPDATE_INTEGRATIONS || ''),
}

const databaseManagement: any = {
  getDatabaseList: buildApiUrl(process.env.REACT_APP_API_DATABASE_LIST || ''),
  getDatabaseSchemas: buildApiUrl(process.env.REACT_APP_API_DATABASE_SCHEMAS || ''),
  getDatabaseTables: buildApiUrl(process.env.REACT_APP_API_DATABASE_TABLES || ''),
  getDatabaseColumns: buildApiUrl(process.env.REACT_APP_API_DATABASE_COLUMNS || ''),
  saveIntegrations: buildApiUrl(process.env.REACT_APP_API_SAVE_INTEGRATIONS || ''),
}

const featureManagement: any = {
  featureSetings: buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_FEATURE_SETTINGS || ''),
  updateStatus: buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_UPDATE_FEATURE_SETTINGS_STATUS || ''),
  createFeatureIntegration: buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_CREATE_FEATURE_INTEGRATION_SETTINGS || ''),
  addFolderGroup: (type: any) => buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_ADD_CATEGORIES_FOLDER?.replace("{type}", type) || ''),
  updateTicketType: (type: any) => buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_UPDATE_TICKET_TYPES?.replace("{type}", type) || ''),
  updateCompanyInfo: buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_UPDATE_COMPANY_INFO || ''),
  updatePersona: buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_UPDATE_PERSONA || ''),
  getFeatureAppDetails: (appId: any) => buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_GET_APP_FEATURE_DETAILS?.replace("{app_id}", appId) || ''),
  getPacakageDetails: (type: any) => buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_GET_PACKAGE_DETAILS?.replace('{type}', type) || ''),
  updateFeatureSettings: buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_UPDATE_FEATURE_SETTINGS || ''),
  getEndPointUrl: buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_END_POINT_URL || ''),
  getAppId: (appId: any) => buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_GET_APP_ID?.replace("{app_id}", appId) || ''),
  getBlockLevelHistory: (instanceId: any) => buildApiUrl(process.env.REACT_APP_API_BLOCK_LEVEL_HISTORY?.replace("{instance_id}", instanceId) || ''),
  updateCustomField: buildApiUrl(process.env.REACT_APP_API_FEATURE_MANAGER_UPDATE_CUSTOM_FIELD || ''),
  homeDashboardAutosolve: buildApiUrl(process.env.REACT_APP_API_HOMEDASHBOARD_AUTOSOLVE || ''),
  homeDashboardTotal: buildApiUrl(process.env.REACT_APP_API_HOMEDASHBOARD_TOTAL || ''),
  homeDashboardAgentAssist: buildApiUrl(process.env.REACT_APP_API_HOMEDASHBOARD_AGENTASSIST || ''),
  homeDashboardWorkflow: buildApiUrl(process.env.REACT_APP_API_HOMEDASHBOARD_WORKFLOW || ''),
  cxAutosolveFilter: buildApiUrl(process.env.REACT_APP_API_CX_AUTOSOLVE_FILTER || ''),
  CXAutosolveDownload: buildApiUrl(process.env.REACT_APP_API_CX_AUTOSOLVE_DOWNLOAD || ''),
  cxAgentAssistFilter: buildApiUrl(process.env.REACT_APP_API_CX_AGENTASSIST_FILTER || ''),
  cxAgentAssistDownload: buildApiUrl(process.env.REACT_APP_API_CX_AGENTASSIST_DOWNLOAD || ''),
  CxAutosolveFourCards: buildApiUrl(process.env.REACT_APP_API_CX_AUTOSOLVE_FOURCARDS || '')
}

const AutotagListing: any = {
  listAutoTag: (type: any) => buildApiUrl(process.env.REACT_APP_API_AUTOTAGLISTS?.replace('{type}', type) || ''),
}

const TrustforteDocumentData: any = {
  trustforteMailDocumentData: (id: string) => {
    const baseUrl = process.env.REACT_APP_TRUSTFORT_MAILDATAFETCHING
    if (!baseUrl) return undefined
    try {
      const u = new URL(baseUrl)
      const parts = u.pathname.split('/')
      parts[parts.length - 1] = id
      u.pathname = parts.join('/')
      return u.toString()
    } catch (e) {
      return baseUrl.replace(/(app-output\/)\[^\/?#\]+/, `$1${id}`)
    }
  }
}

const ControlroomApi: any = {
  gettreeData: buildApiUrl(process.env.REACT_APP_API_STARTTREEAPI || ''),
  sourcetreeData: buildApiUrl(process.env.REACT_APP_API_SOURCETREEAPI || ''),
  pinotQuery: buildApiUrl(process.env.REACT_APP_API_PINOT_QUERY || ''),
  naturalLanguageQueryTranslation: buildApiUrl(process.env.REACT_APP_API_NATURAL_LANGUAGE_QUERY_TRANSLATION || ''),
  discoverSaveFilter: buildApiUrl(process.env.REACT_APP_API_CONTROL_ROOM_DISCOVER_SCREEN_SAVE_FILTER || ''),
  discoverSavedFilterNames: buildApiUrl(process.env.REACT_APP_API_CONTROL_ROOM_DISCOVER_SCREEN_SAVED_FILTER_NAMES || ''),
  discoverSavedFilterDetails: buildApiUrl(process.env.REACT_APP_API_CONTROL_ROOM_DISCOVER_SCREEN_SAVED_FILTER_DETAILS || ''),
  discoverDynamicQuery: buildApiUrl(process.env.REACT_APP_API_CONTROL_ROOM_DISCOVER_SCREEN_DYNAMIC_QUERY || ''),
  discoverGetColumns: buildApiUrl(process.env.REACT_APP_API_CONTROL_ROOM_DISCOVER_SCREEN_GET_COLUMNS || ''),
  discoverDeleteFilter: (filterId: any) => buildApiUrl(process.env.REACT_APP_API_CONTROL_ROOM_DISCOVER_SCREEN_DELETE_FILTER?.replace('{filter_id}', filterId) || ''),
  supersetCredentials: buildApiUrl(process.env.REACT_APP_CONTROL_ROOM_SUPERSET_VAULT_AUTH_URL || ''),
  supersetLogin: buildApiUrl(process.env.REACT_APP_SUPERSET_LOGIN_API || ''),
  supersetCsrfToken: buildApiUrl(process.env.REACT_APP_SUPERSET_CSRF_TOKEN_API || ''),
  supersetChartAPI: (chartId: any) => buildApiUrl(process.env.REACT_APP_SUPERSET_CHART_API?.replace('{chart_id}', chartId) || ''),
  supersetChartData: buildApiUrl(process.env.REACT_APP_SUPERSET_CHART_DATA_API || ''),
  supersetChartID: buildApiUrl(process.env.REACT_APP_SUPERSET_CHART_ID_GET || ''),
  supersetUrl: buildApiUrl(process.env.REACT_APP_SUPERSET_URL || ''),
  supersetGuestToken: buildApiUrl(process.env.REACT_APP_SUPERSET_GUEST_TOKEN_API || ''),
  supersetIframeUrl: process.env.REACT_APP_SUPERSET_IFRAME_URL || '',
  supersetCustomDashboardList: buildApiUrl(process.env.REACT_APP_SUPERSET_CUSTOM_DASHBOARD_LIST || ''),
  discoverGetFilterList: buildApiUrl(process.env.REACT_APP_API_CONTROL_ROOM_DISCOVER_SCREEN_GET_FILTER_LIST || ''),
  organizationSummaryDriverFilter: buildApiUrl(process.env.REACT_APP_API_CONTROL_ROOM_DRIVER_FILTERS || ''),
  listAlertsForControlRoom: buildApiUrl(process.env.REACT_APP_API_LIST_ALERTS || ''),
  listReportsForControlRoom: buildApiUrl(process.env.REACT_APP_API_LIST_REPORTS || ''),
  addNewReport: buildApiUrl(process.env.REACT_APP_API_INSERT_REPORTS || ''),
  getColumnValues: buildApiUrl(process.env.REACT_APP_API_GET_ALERTS_FILTER || ''),
  getAlertDetails: buildApiUrl(process.env.REACT_APP_API_GET_ALERT_DETAILS || ''),
  createAlerts: buildApiUrl(process.env.REACT_APP_API_CREATE_ALERTS || ''),
  updateAlerts: buildApiUrl(process.env.REACT_APP_API_UPDATE_ALERTS || ''),
  deleteReports: (report_id: any) => buildApiUrl(process.env.REACT_APP_API_DELETE_REPORTS?.replace("{report_id}", report_id) || ''),
  deleteAlerts: buildApiUrl(process.env.REACT_APP_API_DELETE_ALERTS || ''),
}

const chatBotApi: any = {
  chatBotTest: buildApiUrl(process.env.REACT_APP_API_CHATBOT_API || ''),
  chatBotTestAdithyaBirla: buildApiUrl(process.env.REACT_APP_API_CHATBOT_API_ADITYA_BIRLA || ''),
}

const autoSolveApis: any = {
  getWidgetDetails: (tool_id: any) => process.env.REACT_APP_API_WIDGET_MANAGMENT_GET_WIDGET_DETAILS?.replace("{tool_id}", tool_id),
  deleteWidget: (tool_id: any) => process.env.REACT_APP_API_WIDGET_MANAGMENT_DELETE_WIDGET?.replace("{tool_id}", tool_id),
  getBotDetails: (botId: any) => process.env.REACT_APP_API_AUTO_SOLVE_GET_BOT_DETAILS?.replace("{bot_id}", botId),
  updateBot: process.env.REACT_APP_API_AUTO_SOLVE_UPDATE_BOT,
  testBot: process.env.REACT_APP_API_AUTO_SOLVE_TEST_BOT,
  getAgentList: (tenant_feature_id: any, app_feature_id: any) => process.env.REACT_APP_API_AUTO_SOLVE_GET_AGENT_LIST?.replace("{tenant_feaure_id}", tenant_feature_id)?.replace('{app_feature_id}', app_feature_id),
  getAgentVersions: (agent_id: any) => process.env.REACT_APP_API_AUTO_SOLVE_AGENT_VERSION?.replace("{agent_id}", agent_id),
  getDefaultAgent: (agent_id: any) => process.env.REACT_APP_API_AUTO_SOLVE_DEFAULT_AGENT?.replace("{agent_id}", agent_id),
  setAgentDefault: process.env.REACT_APP_API_AUTO_SOLVE_AGENT_DEFAULT,
  publishAgent: process.env.REACT_APP_API_AUTO_SOLVE_AGENT_PUBLISH,
  getInstallationList: process.env.REACT_APP_API_AUTO_SOLVE_GET_INSTALLATION_LIST,
  createAgent: process.env.REACT_APP_API_WIDGET_MANAGEMENT_CREATE_AGENT,
  createBot: process.env.REACT_APP_API_AUTO_SOLVE_CREATE_BOT,
  updateAgent: process.env.REACT_APP_API_WIDGET_MANAGEMENT_UPDATE_AGENT,
  deleteAgent: (agentId: any) => process.env.REACT_APP_API_WIDGET_MANAGEMENT_DELETE_AGENTS?.replace("{id}", agentId),
  getAgentTestHistory: (agentId: any) => process.env.REACT_APP_API_AUTO_SOLVE_AGENT_TEST_HISTORY?.replace("{agent_id}", agentId),
  getAgentRunHistory: (agentId: any) => process.env.REACT_APP_API_AUTO_SOLVE_AGENT_RUN_HISTORY?.replace("{agent_id}", agentId),
  getBotRunHistory: (botId: any) => process.env.REACT_APP_API_AUTO_SOLVE_BOT_RUN_HISTORY?.replace("{bot_id}", botId),
  getBotRunHistoryOfConversation: (botId: any, conversationId: any) => process.env.REACT_APP_API_AUTO_SOLVE_BOT_RUN_HISTORY_OF_CONVERSATION?.replace("{bot_id}", botId).replace("{conversation_id}", conversationId),
  getAgentAssistConversationList: process.env.REACT_APP_API_AGENTASSIST_CONVERSATON_LIST,
  getAgentAssistConversationDetail: (conversationId: any) => process.env.REACT_APP_API_AGENTASSIST_CONVERSATION_DETAIL?.replace("{conversation_id}", conversationId),
  getAgentAssistFilterDetails: process.env.REACT_APP_API_AGENTASSIST_FILTER_DETAILS,
  generateCode: process.env.REACT_APP_API_AUTO_SOLVE_GENERATE_CODE,
  getAutosolveConversations: process.env.REACT_APP_API_AUTOSOLVE_CONVERSATIONS,
  getBotTestHistory: (botId: any, conversationId: any) => process.env.REACT_APP_API_AUTO_SOLVE_BOT_TEST_HISTORY?.replace("{bot_id}", botId)?.replace("{conversation_id}", conversationId),
  saveFeedBackAutoSolve: process.env.REACT_APP_API_AUTO_SOLVE_BOT_FEEDBACK,
  autoSolveMetaData: process.env.REACT_APP_API_AUTO_SOLVE_META_DATA,
  downloadCsvReport: process.env.REACT_APP_API_AUTO_SOLVE_DOWNLOAD_CSV_REPORT,
  downloadCsvReportAgentAssist: process.env.REACT_APP_API_CSV_REPORT_AGENT_ASSIST,
  getMasterData: process.env.REACT_APP_API_AUTO_SOLVE_MASTER_DATA,
  cloneAutosolveFeature: process.env.REACT_APP_API_AUTO_SOLVE_CLONE_FEATURE,
  createAutoSolveFeature: process.env.REACT_APP_API_AUTO_SOLVE_CREATE_FEATURE,
  validateChannel: (channelType: any) => process.env.REACT_APP_API_VALIDATE_CHANNEL?.replace("{channel_type}", channelType),
  getAgentDetails: (agent_id: any) => process.env.REACT_APP_API_AUTO_SOLVE_GET_AGENT_DETAILS?.replace("{id}", agent_id),
  getAgentVersion: (agent_id: any) => process.env.REACT_APP_API_AUTO_SOLVE_AGENT_VERSION?.replace("{agent_id}", agent_id),
  getAutoSolveBlockLevelHistory: (bot_id: any, conversation_id: any) => process.env.REACT_APP_API_AUTO_SOLVE_BLOCK_LEVEL_HISTORY?.replace("{bot_id}", bot_id)?.replace("{conversation_id}", conversation_id),
  getllmModelDetails: process.env.REACT_APP_API_AUTO_SOLVE_GET_LLM_MODEL_DETAILS,
  getAllLlmModelDetails: process.env.REACT_APP_API_AUTO_SOLVE_GET_ALL_LLM_MODEL_DETAILS,
  fileuploadBulkrun: process.env.REACT_APP_API_AUTO_SOLVE_FILE_UPLOAD,
  autosolverunbatch: process.env.REACT_APP_API_AUTO_SOLVE_BULK_RUN_RUN_BATCH,
  autosolveTestHistory: (botId: string) => process.env.REACT_APP_API_AUTO_SOLVE_TEST_HISTORY?.replace("{bot_id}", botId),
  getConersationHistory: (botId: any, conversationId: any) => process.env.REACT_APP_API_AUTO_SOLVE_CONVERSATION_HISTORY?.replace("{bot_id}", botId)?.replace("{conversation_id}", conversationId),
  sendmessagetouser: process.env.REACT_APP_SEND_MESSAGE_TO_USER,
  acceptUserRequest: process.env.REACT_APP_ACCEPT_USER_REQUEST,
  chatnegotaite: (user_id: any) => process.env.REACT_APP_CHAT_NEGOTIATE?.replace("{user_id}", user_id),
  notificationnegotaite: (bot_id: any) => process.env.REACT_APP_NOTIFICATION_NEGOTIATE?.replace("{user_id}", bot_id),
  createSpecifyingCase: process.env.REACT_APP_FCA_CREATE_CASE_URL,
  realTimeAudio: process.env.REACT_APP_REALTIME_AUDIO_LIST,
  customerInteractionAutosolveHistory: process.env.REACT_APP_CUSTOMER_INTERACTION_AUTOSOLVE_HISTORY,
  LiveAgentNotifications: process.env.REACT_APP_LIVEAGENT_NOTIFICATIONS,
  LiveAgentEndCall: process.env.REACT_APP_LIVEAGENT_END_CALL,
  latestPublishedApp: (appId: any) => process.env.REACT_APP_API_LATEST_PUBLISHED_APP?.replace("{app_id}", appId),
  customerInteractionAgentAssistHistory: process.env.REACT_APP_CUSTOMER_INTERACTION_AGENTASSIST_HISTORY,
  cxAgentAssistCardDetails: process.env.REACT_APP_API_CX_AGENT_ASSIST_CARD_DETAILS,
  updateactiveliveagent: process.env.REACT_APP_UPDATE_ACTIVE_LIVEAGENT,
  removeactiveliveagent: process.env.REACT_APP_REMOVE_ACTIVE_LIVEAGENT,
  exportAutosolve: (botId: any) => process.env.REACT_APP_API_AUTOSOLVE_EXPORT?.replace("{agentic_app_id}", botId),
  importAutosolve: (flag: any) => process.env.REACT_APP_API_AUTOSOLVE_IMPORT?.replace("{flag}", String(flag))
}

const widgetManagement: any = {
  listWidgets: buildApiUrl(process.env.REACT_APP_API_WIDGET_MANAGEMENT_LIST_WIDGETS || ''),
  listWidgetTypes: buildApiUrl(process.env.REACT_APP_API_WIDGET_MANAGEMENT_LIST_WIDGETS_TYPES || ''),
  createWidgets: buildApiUrl(process.env.REACT_APP_API_WIDGET_MANAGEMENT_CREATE_WIDGETS || ''),
  deleteWidgets: (widgetId: any) => buildApiUrl(process.env.REACT_APP_API_WIDGET_MANAGEMENT_DELETE_WIDGETS?.replace("{widget_id}", widgetId) || ''),
  testWidgets: buildApiUrl(process.env.REACT_APP_API_WIDGET_MANAGEMENT_TEST_WIDGETS || ''),
  getToolsList: buildApiUrl(process.env.REACT_APP_API_WIDGET_MANAGEMENT_LIST_TOOLS || ''),
  updateWidgets: buildApiUrl(process.env.REACT_APP_API_WIDGET_MANAGMENT_UPDATE_WIDGET || ''),
  widgetHistory: (tool_id: any) => buildApiUrl(process.env.REACT_APP_API_GET_WIDGET_HISTORY?.replace("{tool_id}", tool_id) || ''),
  widgetObject: (bot_key: any) => buildApiUrl(process.env.REACT_APP_API_WIDGET_MANAGMENT_GET_WIDGET_OBJECT?.replace("{bot_key}", bot_key) || ''),
  getMcpTools: process.env.REACT_APP_WIDGETS_MCP_TOOLS,

}

const EnterPriseHubManagement: any = {
  getActiveEnterPriseHubList: process.env.REACT_APP_API_ENTERPRISEHUB_GET_ACTIVE_LIST,
  updateEnterPriseHub: process.env.REACT_APP_API_ENTERPRISEHUB_UPDATE_LIST,
  getTrustforteList: process.env.REACT_APP_TRUSTFORT_LISTING,
  getExHubHistory: process.env.REACT_APP_EXHUB_HISTORY,
  getTemplateList: process.env.REACT_APP_API_TEMPLATE_LISTING,
  fetchTemplateDetails: process.env.REACT_APP_API_TEMPLATE_FETCH,
  uploadTemplate: process.env.REACT_APP_UPLOAD_TEMPLATE_API,
  deleteTemplate: (folderId: any, initiated_by: any, id: any) => process.env.REACT_APP_DELETE_TEMPLATE_API?.replace("{folder_id}", folderId)?.replace("{initiated_by}", initiated_by)?.replace("{id}", id ?? ''),
}

const seekerApis: any = {
  getSeekerCards: buildApiUrl(process.env.REACT_APP_API_CX_SEEKER_CARDS || ''),
  getSeekerHistoryList: buildApiUrl(process.env.REACT_APP_API_CX_SEEKER_HISTORY_LIST || ''),
  downloadSeekerCsv: buildApiUrl(process.env.REACT_APP_API_CX_SEEKER_CSV_DOWNLOAD || ''),
  updateSeekerFeedback: buildApiUrl(process.env.REACT_APP_API_CX_SEEKER_FEEDBACK || ''),
  pinotQueryApi: buildApiUrl(process.env.REACT_APP_API_PINOT_QUERY || '')
}

const langfuseApis: any = {
  getRedirectUrl: (type: string) => process.env.REACT_APP_API_LANGFUSE_REDIRECT?.replace("{type}", type),
  evalsRunStatus: process.env.REACT_APP_API_APP_MANAGER_APP_EVAL_RUN_STATUS,
  getEvalDatasets: (type: string, agent_id: string) => process.env.REACT_APP_API_EVAL_DATASET?.replace("{agent_id}", agent_id).replace("{type}", type),
  getEvalHistory: (type: string, agent_id: string) => process.env.REACT_APP_API_EVAL_HISTORY?.replace("{agent_id}", agent_id).replace("{type}", type),
  evalRunAgent: process.env.REACT_APP_API_EVAL_RUN_AGENT,
  evalRunApp: process.env.REACT_APP_API_EVAL_RUN_APP,
  createEvalDataset: process.env.REACT_APP_API_EVAL_CREATE_DATASET,
  updateTelemetry: process.env.REACT_APP_API_TELEMETRY_UPDATE
}

const contentManagementApiUrls: {
  webchatStaticFiles: (fileType: string, webchatType: string) => string
} = {
  webchatStaticFiles: (fileType: string, webchatType: string) =>
    buildApiUrl(
      `${process.env.REACT_APP_API_WEBCHAT_STATIC_FILES || ''}?file_type=${encodeURIComponent(fileType)}&webchat_type=${encodeURIComponent(webchatType)}`
    ),
}

const billingTokenUrls: {
  tokenUsageSummary: string
  tokenUsage: (type: string) => string
} = {
  tokenUsageSummary: buildApiUrl(process.env.REACT_APP_API_BILLING_TOKEN_SUMMARY || ''),
  tokenUsage: (type: string) =>
    buildApiUrl(process.env.REACT_APP_API_BILLING_TOKEN_USAGE?.replace('{type}', type) || ''),
}

export {
  llmConfigUrls,
  promptManagerAPIUrls, systemConfigUrls, contentFolderApiUrls,
  fileManagerAPIUrls, appManagerAPIUrls, fileUrls, userManagementUrls, orchestratorApiUrls, tenantManagement, accessManagement, rolesManagement, packageManagement, productManagement,
  integrationManagement, databaseManagement, featureManagement, AutotagListing, ControlroomApi, chatBotApi, autoSolveApis, widgetManagement, EnterPriseHubManagement, seekerApis, TrustforteDocumentData, langfuseApis,
  contentManagementApiUrls,
  billingTokenUrls,
}


